<h2 mat-dialog-title>{{ data == null ? "Nuevo" : "Editar" }} buz&oacute;n</h2>
<mat-dialog-content>
    <app-tree-autocomplete [dptos]="departamentos" (onSelected)="trackDepartamentoChanges($event)" class="full-width" />

    <mat-form-field class="full-width">
      <mat-label>Departamento seleccionado</mat-label>
      <input matInput [formControl]="departamentoControl" placeholder="Departamento" readonly="">
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Cargo/nombre del buzón</mat-label>
      <input matInput [formControl]="cargosControl" type="text" placeholder="Cargo">
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Servidor p&uacute;blico</mat-label>
      <input type="text" matInput [formControl]="participanteControl" [matAutocomplete]="autoParticipante"
        (focus)="selectAllText($event)">
      <mat-autocomplete #autoParticipante="matAutocomplete" [displayWith]="displayParticipanteFn"
        (optionSelected)="addResponsable($event.option.value)">
        @for (participante of participantesFiltered | async; track participante) {
        <mat-option [value]="participante" style="display: block;">
          <div><span>{{participante.apellidos.trim()+" "+participante.nombres.trim()}}</span> </div>
          <small>{{(participante.cargo||'')+" "+participante.ciruc}} </small>
          <span class="sgd-spacer"></span>
          <mat-icon class="ultimo-uso-{{participante.fechaUso|ultimoUso}}"
            style="float: inline-end; margin-right: 0;">man</mat-icon>
        </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

  <table mat-table [dataSource]="funcionariosDataSource">
    <ng-container matColumnDef="titular">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Titular </th>
      <td mat-cell *matCellDef="let funcionario">
        <mat-radio-button [checked]="funcionario.titular === 1" (click)="onTitularChange($event, funcionario)"
          [value]="funcionario.titular"></mat-radio-button>
      </td>
    </ng-container>

    <ng-container matColumnDef="encargado">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Encargado </th>
      <td mat-cell *matCellDef="let funcionario">
        <mat-radio-button [checked]="funcionario.encargado === 1" (click)="onEncargadoChange($event, funcionario)"
          name="encargado" [value]="funcionario.encargado"></mat-radio-button>
      </td>
    </ng-container>

    <ng-container matColumnDef="suscrito">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Suscrito </th>
      <td mat-cell *matCellDef="let funcionario">
        <mat-checkbox [checked]="funcionario.suscrito === 1" (change)="onSuscritoChange($event, funcionario)"
          name="suscrito" [value]="funcionario.suscrito"></mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="funcionario">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Funcionario </th>
      <td mat-cell *matCellDef="let funcionario">{{ funcionario.participante}}</td>
    </ng-container>

    <ng-container matColumnDef="opt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> &nbsp; </th>
      <td mat-cell *matCellDef="let funcionario">
        <button mat-icon-button (click)="onDelete(funcionario)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="onCancelarClick()">Cancelar</button>
  <button mat-button color="primary" (click)="onGuardarClick()">Guardar</button>
</mat-dialog-actions>